import { cn } from "@/lib/utils";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import type { ComponentPropsWithRef } from "react";
import { getTooltipStyles, tooltipAnimationStyles } from "../tooltip-styles";

const TooltipProvider = TooltipPrimitive.Provider;
const Tooltip = TooltipPrimitive.Root;
const TooltipPortal = TooltipPrimitive.Portal;

const TooltipTrigger = ({
  ref,
  ...props
}: ComponentPropsWithRef<typeof TooltipPrimitive.Trigger>) => (
  <TooltipPrimitive.Trigger ref={ref} {...props} />
);
TooltipTrigger.displayName = "TooltipTrigger";

// Styled to match the ui/tooltip.tsx component
const TooltipContent = ({
  className,
  sideOffset = 4,
  ref,
  ...props
}: ComponentPropsWithRef<typeof TooltipPrimitive.Content>) => (
  <TooltipPrimitive.Content
    ref={ref}
    data-slot="tooltip-content"
    sideOffset={sideOffset}
    className={cn(getTooltipStyles("white", className), tooltipAnimationStyles)}
    {...props}
  />
);
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
  TooltipPortal,
};
